module.exports = __webpack_public_path__ + "static/img/1.a0f4fde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-fr/1.jpg
// module id = bYg6
// module chunks = 1